import SingleProductCard from "./SingleProductCard";

export default SingleProductCard;
